import Vue from 'vue'
import axios from 'axios'
/******************************************************
 * 腾讯云cloudbase 接口
 * cloudbase文档地址：https://docs.cloudbase.net/database/read
 * author: stone
 * ****************************************************
 */

const db = Vue.prototype.$app.database()
const currentUser = Vue.prototype.$app.auth().currentUser

const DOMAIN = 'https://saas.api.lightio.cc'
// const DOMAIN = 'https://api-sta.devops.back.aiyaopai.com'

export default {
  // 获取网页列表
  getPages: (pageIndex, pageSize, visible) => {
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .where(
          currentUser
            ? { _openid: '{openid}', visible: visible }
            : { visible: visible }
        )
        .skip((pageIndex - 1) * pageSize)
        .limit(pageSize)
        .orderBy('create_time', 'desc')
        .get()
        .then((res) => {
          db.collection('pages')
            .where(
              currentUser
                ? { _openid: '{openid}', visible: visible }
                : { visible: visible }
            )
            .count()
            .then((res2) => {
              res.total = res2.total
              resolve(res)
            })
        })
    })
  },

  /**
   * 获取直播详情信息
   * @param {*} albumId
   * @returns
   */
  getLiveInfo: (albumId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${DOMAIN}/livealbum/${albumId}`)
        .then((res) => {
          resolve(res)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  /**
   * 获取geren信息
   * @param {*} userId
   * @returns
   */
  getUserInfo: (userId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${DOMAIN}/user/${userId}`)
        .then((res) => {
          resolve(res)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  /**
   * 获取团队信息
   * @param {*} teamId
   * @returns
   */
  getTeamInfo: (teamId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${DOMAIN}/team/${teamId}`)
        .then((res) => {
          resolve(res)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  /**
   * 获取客户经理信息
   * @param {*} userId
   * @returns
   */
  getAgentInfo: (userId) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${DOMAIN}/manager/${userId}`)
        .then((res) => {
          resolve(res)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  // 通过id获取网页
  getPageById: (id) => {
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .where(currentUser ? { _id: id, _openid: '{openid}' } : { _id: id })
        .get()
        .then((res) => {
          // console.log('--------- getPageById:', res.data[0])
          resolve(res.data[0])
        })
    })
  },

  // 通过id获取网页(visible:true)
  getRenderPageById: (id) => {
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .where(
          currentUser
            ? { _id: id, visible: true, _openid: '{openid}' }
            : { _id: id, visible: true }
        )
        .get()
        .then((res) => {
          // console.log('--------- getPageById:', res.data[0])
          resolve(res.data[0])
        })
    })
  },

  // 创建网页
  createPage: () => {
    console.log(1)
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .add({
          cover: 'https://assets.aiyaopai.com/bgss.png?a=1',
          title: '空白页面',
          view: 23,
          visible: true,
          source: {
            webInfo: {
              title: '空白页面',
              description: '暂无描述内容',
              shareIcon: '',
              bgImage: '',
              bgColor: '#fff',
              cover: 'https://assets.aiyaopai.com/bgss.png?a=1'
            },
            launchScreen: {
              enable: false,
              type: 'image',
              src: '',
              delay: 3,
              hasSkip: false,
              skipText: '立即跳过'
            },
            moduleList: [],
            checkMode: false,
            currentModuleIndex: 0,
            checkElementList: []
          },
          creator_id: currentUser.uid,
          create_time: new Date().getTime(),
          update_time: new Date().getTime()
        })
        .then((res) => {
          // console.log('--------- createPage:', res)
          resolve(res)
        })
    })
  },

  // 删除页面（假）
  deletePage: (id) => {
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .where(currentUser ? { _id: id, _openid: '{openid}' } : { _id: id })
        .update({
          visible: false,
          update_time: new Date().getTime()
        })
        .then((res) => {
          console.log('--------- deletePage:', res)
          resolve(res)
        })
    })
  },

  // 删除页面（假）
  trueDeletePage: (id) => {
    // 真实删除
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .where(currentUser ? { _id: id, _openid: '{openid}' } : { _id: id })
        .remove()
        .then((res) => {
          console.log('--------- deletePage:', res)
          resolve(res)
        })
    })
  },

  // 恢复页面
  resumePage: (id) => {
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .where(currentUser ? { _id: id, _openid: '{openid}' } : { _id: id })
        .update({
          visible: true,
          update_time: new Date().getTime()
        })
        .then((res) => {
          console.log('--------- resumePage:', res)
          resolve(res)
        })
    })
  },

  // 更新页面
  updatePageById: (id, source) => {
    return new Promise((resolve, reject) => {
      db.collection('pages')
        .where(currentUser ? { _id: id, _openid: '{openid}' } : { _id: id })
        .update({
          title: source.webInfo.title,
          source: source,
          cover: source.webInfo.cover,
          update_time: new Date().getTime()
        })
        .then((res) => {
          console.log('--------- updatePage:', res)
          resolve(res)
        })
    })
  },

  // 获取wechat jsapi签名对象
  jsapiSignature: (url) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          'https://livewechatauth.aiyaopai.com/auth/jsapisignature?url=' + url
        )
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          console.error(
            '===========> jsapiSignature 接口异常：',
            err.response ? err.response.data.Message : err
          )
          reject(err)
        })
    })
  }
}
